import { render } from "./GenericFormWrapper.vue?vue&type=template&id=2c8a79dc&scoped=true&ts=true"
import script from "./GenericFormWrapper.vue?vue&type=script&lang=ts"
export * from "./GenericFormWrapper.vue?vue&type=script&lang=ts"

import "./GenericFormWrapper.vue?vue&type=style&index=0&id=2c8a79dc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8a79dc"]])

export default __exports__